import React, { PureComponent } from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { possibleValues } from '../../ws/constants';
import './style.css';

class ProfileField extends PureComponent {
    render() {
        const { mainField, fieldInfo, page, checkedValue, disabled, handleToggle } = this.props;
        const fieldName = page + "_" + fieldInfo.fieldName;
        
        if(mainField){
            return (
                <h2>{fieldInfo.displayName}
                    <div className="float-right profileCheckboxHolder" onChange={(e) => handleToggle(e, fieldInfo.fields)}>
                        { fieldInfo.validValues.includes(possibleValues.EDIT) && 
                            <FormControlLabel 
                                label="Editar" 
                                control={ <Checkbox 
                                    name={"f_" + page}
                                    value={possibleValues.EDIT} 
                                    color="primary"
                                    disabled={disabled}
                                    checked={checkedValue === possibleValues.EDIT} />
                                } 
                            />
                        }
                        { fieldInfo.validValues.includes(possibleValues.VIEW) && 
                            <FormControlLabel 
                                label="Apenas ver"
                                control={<Checkbox 
                                    name={"f_" + page} 
                                    value={possibleValues.VIEW} 
                                    color="primary" 
                                    disabled={disabled}
                                    checked={checkedValue === possibleValues.VIEW} />
                                }  
                            />
                        }
                    </div>
                </h2>
            );
        }
        
        return (
            <p className="fieldCheckboxHolder">
                <span>{fieldInfo.displayName}</span>
                <span className="float-right profileCheckboxHolder" onChange={handleToggle}>
                    { fieldInfo.validValues.includes(possibleValues.EDIT) && 
                        <FormControlLabel 
                            label="Editar" 
                            control={ <Checkbox 
                                name={"f_" + fieldName} 
                                value={possibleValues.EDIT} 
                                color="primary" 
                                disabled={disabled}
                                checked={checkedValue === possibleValues.EDIT}/>
                            } 
                        />
                    }
                    { fieldInfo.validValues.includes(possibleValues.VIEW) && 
                        <FormControlLabel 
                            label="Apenas ver" 
                            control={ <Checkbox 
                                name={"f_" + fieldName} 
                                value={possibleValues.VIEW} 
                                color="primary" 
                                disabled={disabled}
                                checked={checkedValue === possibleValues.VIEW} />
                            }
                        />
                    }
                </span>
            </p>
        );
    }
}

export default ProfileField;
